import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
} from "@material-ui/core";

import Btn from "../../../../components/buttons/Btn";
import { mismatchTypeActions } from "../constants/constants";
import { ValueSpan } from "../ConciliacaoBancaria";
import { useContext } from "react";
import { ConciliacaoBancariaContext } from "../contexts/ConciliacaoBancariaContext";
import moment from "moment";
import { codigoJurosMora, fineFessDescription } from "../constants/constants";
import { notify } from "../../../../utils/notify";

const ModalMismatchValue = ({
  open,
  setModalOpen,
  transactionAmount,
  pending,
  setModalVisualizationOpen,
  setAddPayments,
  transactionType,
  transactionDateString,
  setPendingsCopy,
  handleChangeStatus = async () => {},
}) => {
  const { bankAccount, mismatchValue, setNeedMismatchValueFullfill } =
    useContext(ConciliacaoBancariaContext);

  const handleClose = () => {
    setModalOpen(false);
  };

  const isDebit = transactionType === "DEBIT";
  const isCredit = transactionType === "CREDIT";
  const receivables = pending.filter(
    (account) => account.typeBill === "accountsReceivable"
  );
  const payables = pending.filter(
    (account) => account.typeBill === "accountsPay"
  );

  const accountMovimentation = pending.filter(
    (account) => account.typeBill === "movimentationsBank"
  );

  const setMismatchTypeFineFees = () => {
    const modifiedPending = JSON.parse(JSON.stringify(pending));
    if (receivables.length > 0) {
      modifiedPending.map((receivable) => {
        if (receivable.typeBill === "accountsReceivable") {
          const expirationDate = moment(receivable.datavencto, "YYYY-MM-DD");
          const transactionDate = moment(transactionDateString, "YYYY-MM-DD");
          const dateDiff = transactionDate.diff(expirationDate, "days");
          const finePercent =
            parseFloat(bankAccount?.boleto_porcentagemmulta) / 100 ?? 0;
          const agencyFeesPercent =
            parseFloat(bankAccount?.boleto_porcentagemjurosmora) / 100;
          let feesPercent = 0.0;
          if (
            bankAccount?.boleto_codigojurosmora === codigoJurosMora.month.value
          ) {
            feesPercent = parseFloat(agencyFeesPercent) / 30;
          } else if (
            bankAccount?.boleto_codigojurosmora === codigoJurosMora.day.value
          ) {
            feesPercent = parseFloat(agencyFeesPercent);
          }
          if (dateDiff > 0) {
            feesPercent = feesPercent * dateDiff;
          }

          receivable.multaPercent = bankAccount?.boleto_porcentagemmulta;
          receivable.jurosPercent = feesPercent * 100;
          receivable.fine = receivable.valordocto * finePercent;
          receivable.fees = receivable.valordocto * feesPercent;
        }
        return receivable;
      });
      notify(
        `Juros calculado com base no valor diário. Tipo de juros da agência: ${
          fineFessDescription[bankAccount?.boleto_codigojurosmora]
        }.`,
        false,
        "info"
      );
    }
    setPendingsCopy(modifiedPending);
    setNeedMismatchValueFullfill(true);
    setAddPayments(isDebit);
    setModalVisualizationOpen(true);
    handleClose();
  };

  const setMismatchTypeCredit = () => {
    const lastReceivableId = receivables[receivables.length - 1]?.id;
    const lastPayableId = payables[payables.length - 1]?.id;
    const lastAccountMovimentationId =
      accountMovimentation[pending.length - 1]?.id;
    pending.map((account) => {
      if (
        account.id === lastPayableId ||
        account.id === lastReceivableId ||
        account.id === lastAccountMovimentationId
      ) {
        account.gera_credito = "S";
        account.creditValue = mismatchValue * -1;
      }
      return account;
    });
    handleChangeStatus("pendente");
    handleClose();
  };

  const setMismatchTypeIgnore = () => {
    const lastReceivableId = receivables[receivables.length - 1]?.id;
    const lastPayableId = payables[payables.length - 1]?.id;
    const lastAccountMovimentationId =
      accountMovimentation[pending.length - 1]?.id;
    pending.map((account) => {
      if (
        account.id === lastPayableId ||
        account.id === lastReceivableId ||
        account.id === lastAccountMovimentationId
      ) {
        account.gera_credito = "N";
      }
      return account;
    });
    handleChangeStatus("pendente");
    handleClose();
  };

  const setMismatchTypeRebate = () => {
    const modifiedPending = JSON.parse(JSON.stringify(pending));
    if (isCredit) {
      if (receivables.length === 1) {
        modifiedPending.map((receivable) => {
          if (receivable.typeBill === "accountsReceivable") {
            receivable.abatement = mismatchValue;
          }
          return receivable;
        });
      }
    } else if (isDebit) {
      if (payables.length === 1) {
        modifiedPending.map((payable) => {
          if (payable.typeBill === "accountsPay") {
            payable.abatement = mismatchValue;
          }
          return payable;
        });
      }
    }
    setPendingsCopy(modifiedPending);
    setNeedMismatchValueFullfill(true);
    setAddPayments(isDebit);
    setModalVisualizationOpen(true);
    handleClose();
  };

  const setMismatchTypePartiallySettled = () => {
    let total = 0;

    pending.map((account) => {
      if (total !== transactionAmount) {
        total = total + Number(account.valordocto);

        if (total > transactionAmount) {
          account.valordocto = (
            Number(account.valordocto) -
            (total - Number(transactionAmount))
          ).toFixed(2);
          total = Number(transactionAmount);
        }
      } else {
        account.valordocto = 0;
      }

      const lastPayableId = payables[payables.length - 1]?.id;
      pending.map((account) => {
        if (account.id === lastPayableId) {
          account.valordocto *= -1;
        }
        return account;
      });

      return account;
    });
    handleChangeStatus("pendente");
    handleClose();
  };

  const smallerTransaction = mismatchValue > 0;
  const greaterTransaction = mismatchValue < 0;

  return (
    <>
      <Dialog open={open} maxWidth="lg">
        <DialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
          children={
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: 22,
              }}
            >
              Valor de Conciliação Divergente
            </div>
          }
        />
        <DialogContent>
          <DialogTitle>
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {mismatchValue > 0 ? (
                <span className="Title" style={{ fontSize: 20 }}>
                  O valor registrado no sistema é MAIOR do que o valor no
                  extrato.
                  <br />
                  O que deseja fazer com a diferença?
                  <br />
                  <br />
                  <b>1. Aplicar Abatimento:</b>
                  <ul>
                    <li>
                      Liquidação Total do título, incorporando a diferença como
                      abatimento (desconto).
                    </li>
                  </ul>
                  <b>2. Liquidação Parcial:</b>
                  <ul>
                    <li>
                      Efetuar a liquidação parcial do título pelo valor indicado
                      no extrato, mantendo o título em aberto.
                    </li>
                  </ul>
                </span>
              ) : (
                <span className="Title" style={{ fontSize: 20 }}>
                  O valor registrado no sistema é MENOR do que o valor no
                  extrato.
                  <br />
                  O que deseja fazer com a diferença?
                  <br />
                  <br />
                  <b>1. Ajuste com Juros e Multa:</b>
                  <ul>
                    <li>Liquidação Total do título incluindo juros e multa</li>
                  </ul>
                  <b>2. Gerar um Novo Título de Crédito:</b>
                  <ul>
                    <li>
                      Liquidação Total do título no valor original e criação do
                      novo título de crédito da diferença.
                    </li>
                  </ul>
                  <b>3. Ignorar a Diferença e Liquidar o Título Atual:</b>
                  <ul>
                    <li>
                      Liquidação Total do título no valor original, ignorando a
                      divergência de valores.
                    </li>
                  </ul>
                </span>
              )}
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: 30,
              }}
            >
              <span
                className="Title"
                style={{
                  fontSize: 22,
                  fontWeight: "bold",
                  marginRight: "10px",
                }}
              >
                Diferença:
              </span>
              <ValueSpan value={mismatchValue} fontSize={22} />
            </div>
          </DialogTitle>
        </DialogContent>
        <DialogActions>
          {greaterTransaction && (
            <Btn
              onClick={() => {
                setMismatchTypeFineFees();
              }}
              label={mismatchTypeActions.fineFees.label}
              bgcolor="primary"
            />
          )}
          {greaterTransaction && (
            <Tooltip
              title={
                pending.length === 1 &&
                pending[0].typeBill === "movimentationsBank"
                  ? "Não é possível lançar crédito para movimentações bancárias"
                  : ""
              }
              placement="top"
            >
              <span>
                <Btn
                  onClick={() => {
                    setMismatchTypeCredit();
                  }}
                  label={mismatchTypeActions.credit.label}
                  disabled={
                    pending.length === 1 &&
                    pending[0].typeBill === "movimentationsBank"
                  }
                  bgcolor="primary"
                />
              </span>
            </Tooltip>
          )}
          {greaterTransaction && (
            <Btn
              onClick={() => {
                setMismatchTypeIgnore();
              }}
              label={mismatchTypeActions.ignore.label}
              bgcolor="primary"
            />
          )}
          {smallerTransaction && (
            <Btn
              onClick={() => {
                setMismatchTypeRebate();
              }}
              label={mismatchTypeActions.rebate.label}
              bgcolor="primary"
            />
          )}
          {smallerTransaction && (
            <Btn
              onClick={() => {
                setMismatchTypePartiallySettled();
              }}
              label={mismatchTypeActions.partiallySettled.label}
              bgcolor="primary"
            />
          )}
          <Btn onClick={handleClose} bgcolor="tertiary" label="Fechar" />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ModalMismatchValue;
